/**
 * OIN catalog search — single `fetch` to `/api/idp/okta/oin-search` (or configured origin).
 * Does not call `/api/ai/chat`; server proxies to Okta only.
 * @see searchCatalogApps in services/oktaApi.js
 */
import { getOinSearchUrl } from "../../config/apiEndpoints.js";
import { getOktaSessionSnapshot } from "../../okta/oktaSessionStore.js";
import { dispatchOktaSswsUnauthorized } from "../../okta/oktaSswsUnauthorizedDispatch.js";

/**
 * @param {string} query
 * @param {{ oktaUrl?: string | null, apiToken?: string | null } | null} [sessionOverride]
 */
export async function handleSearch(query, sessionOverride = null) {
  const snap = getOktaSessionSnapshot();
  const oktaUrl = String(sessionOverride?.oktaUrl ?? snap.orgUrl ?? "")
    .trim()
    .replace(/\/$/, "");
  const apiToken = String(sessionOverride?.apiToken ?? snap.apiToken ?? "").trim();
  if (!oktaUrl || !apiToken) {
    throw new Error("Okta org URL and API token are required to search the tenant OIN catalog (GET /api/v1/catalog/apps).");
  }
  const url = getOinSearchUrl();
  const body = { q: query, oktaUrl, apiToken };
  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401) dispatchOktaSswsUnauthorized();
    const err = new Error(json.errorSummary || json.error || `Request failed (${res.status})`);
    err.errorCode = json.errorCode;
    err.status = res.status;
    throw err;
  }
  return json;
}
